<template>
    <div class="absolute w-[12px] h-[12px]" :class="pinging?'animate-wiggle':''"
         v-if="item && (item.materials.length || item.labour.length || item.fixedCosts.length)">
        <div class="absolute inline-block animate-[ping_300ms_linear_infinite] w-[12px] h-[12px]" v-show="pinging">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12px"
                height="12px"
                viewBox="0 0 24 24"
                :fill="color"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-gray-400"
            >
                <circle cx="12" cy="12" r="11" v-if="shape==='circle'"/>
                <path d="M0 0h24v24h-24z" v-else-if="shape==='square'"/>
                <path d="M24 22h-24l12-20z" v-else-if="shape==='triangle'"/>
                <path
                    d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
                    v-else-if="shape==='star'"/>
            </svg>
        </div>
        <div class="absolute inline-block w-[12px] h-[12px]">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12px"
                height="12px"
                viewBox="0 0 24 24"
                :fill="color"
                stroke="currentColor"
                stroke-width="1"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="text-gray-400"
            >
                <circle cx="12" cy="12" r="11" v-if="shape==='circle'"/>
                <path d="M0 0h24v24h-24z" v-else-if="shape==='square'"/>
                <path d="M24 22h-24l12-20z" v-else-if="shape==='triangle'"/>
                <path
                    d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"
                    v-else-if="shape==='star'"/>
            </svg>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        estimate: Object,
        item: Object,
        pinging: false,
        overrideShape: false,
        overrideColor: false,
    },
    data() {
        return {
            selected: false,
            color: '',
            shape: 'circle',
        }
    },
    watch: {
        "estimate.collectionBuildUUID": {
            handler(newValue, oldValue) {
                this.getItemShapeAndColor();
            },
            deep: true,
        },
    },
    methods: {
        getItemShapeAndColor() {
            this.shape = this.overrideShape ? this.overrideShape : this.estimate.getShape(this.item);
            this.color = this.overrideColor ? this.overrideColor : this.estimate.getColor(this.item);
        },
    },
    mounted() {
        this.getItemShapeAndColor()
    }
}
</script>
